"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("@apollo/client/link/context");
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
const log_1 = require("@aurora/shared-utils/log");
const exenv_1 = require("exenv");
const log = (0, log_1.getLog)(module);
const clientTimeout = process.env.APOLLO_TIMEOUT_CLIENT;
const TIMEOUT_CLIENT = (0, ObjectHelper_1.asNumber)(clientTimeout, 60000);
const serverTimeout = process.env.APOLLO_TIMEOUT_SERVER;
const TIMEOUT_SERVER = (0, ObjectHelper_1.asNumber)(serverTimeout, 10000);
if (!exenv_1.canUseDOM) {
    log.info('Timeouts: client: %dms, server: %dms', TIMEOUT_CLIENT, TIMEOUT_SERVER);
}
if (!AbortSignal.timeout) {
    AbortSignal.timeout = ms => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), ms);
        // Clean up when the signal is aborted
        controller.signal.addEventListener('abort', () => clearTimeout(timeoutId));
        return controller.signal;
    };
}
// see https://github.com/apollographql/apollo-feature-requests/issues/429
const timeoutLink = (0, context_1.setContext)((_, previousContext) => {
    var _a;
    return ({
        fetchOptions: {
            signal: ((_a = previousContext.fetchOptions) === null || _a === void 0 ? void 0 : _a.signal) ||
                AbortSignal.timeout(exenv_1.canUseDOM ? TIMEOUT_CLIENT : TIMEOUT_SERVER)
        }
    });
});
exports.default = timeoutLink;
//# sourceMappingURL=timeoutLink.js.map